import { useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { MachineStatusEditManager } from "components/CaseManagement/CaseDetail/MachineStatus/MachineStatusEditManager";
import { useFetchPost } from "hooks/fetch/useFetchPost";
import { SnackbarQueueContext } from "contexts/SnackbarQueueContext";
import { MachineStatusIdLookup } from "core/enums";

export const MachineStatusCreateRow = ({
  loading,
  caseId,
  machineId,
  machineStatusList,
  machineStatusTypes,
  onSuccess,
  onCancel
}) => {
  const { addSnackbarToQueue } = useContext(SnackbarQueueContext);

  const {
    postCallback: postMachineStatus,
    loading: postMachineStatusLoading
  } = useFetchPost(
    "machine_status",
    () => {
      addSnackbarToQueue({
        message: "Machine status created.",
        severity: "success"
      });
      onSuccess();
    },
    () => {
      addSnackbarToQueue({
        message: "Machine status failed to save.",
        severity: "error"
      });
    }
  );

  let filteredMachineStatusTypes = useMemo(() => {
    // Remove the status corresponding to the most recent status on the same case
    if (machineStatusList && machineStatusList[0]?.case === caseId) {
      return machineStatusTypes.filter(
        rec => rec.id !== machineStatusList[0]?.status
      );
      // Pop the online status if the most recent status is online (from any case)
    } else if (
      machineStatusList &&
      machineStatusList[0]?.status === MachineStatusIdLookup.Online
    ) {
      return machineStatusTypes.filter(
        rec => rec.id !== MachineStatusIdLookup.Online
      );
    } else {
      return machineStatusTypes;
    }
  }, [machineStatusTypes, machineStatusList, caseId]);

  return (
    <MachineStatusEditManager
      testLabel="create"
      loading={loading || postMachineStatusLoading}
      minDate={
        machineStatusList[0]?.date_actioned
          ? new Date(machineStatusList[0].date_actioned)
          : null
      }
      machineStatus={{
        case: caseId,
        machine: machineId,
        status: null,
        date_actioned: null,
        expected_rts: null
      }}
      machineStatusTypes={filteredMachineStatusTypes}
      onSubmit={postMachineStatus}
      onCancel={onCancel}
    />
  );
};

MachineStatusCreateRow.propTypes = {
  loading: PropTypes.bool,
  caseId: PropTypes.number,
  machineId: PropTypes.number,
  machineStatusList: PropTypes.array,
  machineStatusTypes: PropTypes.array,
  onSuccess: PropTypes.func,
  onCancel: PropTypes.func
};
